module.exports = __webpack_public_path__ + "jab/media/cancel2.a5ebf504.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/cancel2.svg
// module id = 507
// module chunks = 0